module.exports = __webpack_public_path__ + "img/1659080815465.df4f1d9b.jpg";